import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { newsList, newsDelete } from "../../../store/actions/websiteActions";
import { Popconfirm, message, Empty } from "antd";
import TableWrapper from "../../../components/Tables";
import Pagination from "../../../components/Pagination";

const NewsIndex = () => {
  const [search, setsearch] = useState("");
  let dispatch = useDispatch();
  let history = useHistory();

  useEffect(() => {
    dispatch(newsList(1, search));
    localStorage.removeItem("id_news");
  }, [dispatch]);

    useEffect(() => {
          if (!userInfo || !userInfo.permission) return;
    if (userInfo.user.roles[0].name == "Super Admin") return;
      if (!userInfo.permission.includes("news-read")) window.location.href = process.env.REACT_APP_LINK_REDIRECT + "403";
    }, []);

  const datanewsList = useSelector((state) => state.newsList);
  const { news, listsNews } = datanewsList;
  console.log(datanewsList);

  const dataLogin = useSelector((state) => state.login);
  let { userInfo } = dataLogin;

  const handleEdit = (id) => {
    localStorage.setItem("id_news", id);
    history.push("/news-edit");
  };

  const handlePageChange = (e, pageNumber) => {
    e.preventDefault();
    dispatch(newsList(pageNumber, search));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(newsList(1, search));
  };

  const listsPaginate = (jumlah_page, current_page) => {
    let item = [];
    for (let index = 1; index <= jumlah_page; index++) {
      item.push(index);
    }
    console.log(item);
    return item.map((page) => {
      if (current_page === 1) {
        if (page === current_page || page === parseInt(current_page) + 1) {
          return (
            <li
              className={
                current_page === page ? "page-item active" : "page-item"
              }
            >
              <a
                className="page-link"
                href="#"
                onClick={(e) => handlePageChange(e, page)}
              >
                {page}
              </a>
            </li>
          );
        }
      } else if (current_page === jumlah_page) {
        if (page === current_page || page === parseInt(current_page) - 1) {
          return (
            <li
              className={
                current_page === page ? "page-item active" : "page-item"
              }
            >
              <a
                className="page-link"
                href="#"
                onClick={(e) => handlePageChange(e, page)}
              >
                {page}
              </a>
            </li>
          );
        }
      } else {
        if (
          page === parseInt(current_page) - 1 ||
          page === current_page ||
          page === parseInt(current_page) + 1
        ) {
          return (
            <li
              className={
                current_page === page ? "page-item active" : "page-item"
              }
            >
              <a
                className="page-link"
                href="#"
                onClick={(e) => handlePageChange(e, page)}
              >
                {page}
              </a>
            </li>
          );
        }
      }
    });
  };

  const tableHead = [
    { name: "No" },
    { name: "Type" },
    { name: "Title" },
    { name: "Publish Time" },
    { name: "Status" },
    { name: "Action" },
  ];

  const tableBody = [
    { scope: "row" },
    { render: (item) => item.type },
    { render: (item) => item.title },
    { render: (item) => item.publish_time },
    {
      render: (item) => (
        <span
          className={`badge badge-${
            item.active ? "success" : "danger"
          }`}
        >
          {item.active ? "active" : "deactive"}
        </span>
      ),
    },
    {
      render: (item) => (
        <div align="center">
          {userInfo.permission.find((e) => e === "news-edit") ? (
            <button
              onClick={() => handleEdit(item.id)}
              className="btn btn-warning btn-sm"
            >
              <i className="fa fa-pencil"></i> Edit{" "}
            </button>
          ) : null}
          {userInfo.permission.find((e) => e === "news-delete") ? (
            <Popconfirm
              title="Are you sure to delete this parent?"
              onConfirm={() =>
                dispatch(newsDelete(item.id)).then(() =>
                  dispatch(newsList(1, search))
                )
              }
              onCancel={() => message.info("Canceled!")}
              okText="Yes"
              cancelText="No"
            >
              <button className="btn btn-danger btn-sm">
                <i className="fa fa-trash-o"></i> Delete{" "}
              </button>
            </Popconfirm>
          ) : null}
        </div>
      ),
    },
  ];

  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>News</h3>
        </div>
      </div>
      <div className="clearfix"></div>
      <br />
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <div className="row">
                <div className="col-md-6 col-sm-12 col-xs-12">
                  {userInfo.permission.find((e) => e === "news-create") ? (
                    <Link to={"/news-create"} className="btn btn-info btn-sm">
                      Create
                    </Link>
                  ) : null}
                </div>
                <div className="col-md-6 col-sm-12 col-xs-12 form-group has-feedback">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search By Name"
                    style={{ float: "right", width: "50%", textOverflow: "ellipsis", paddingRight: "33px" }}
                    onChange={(e) => setsearch(e.target.value)}
                  />
                  <button
                    className="fa fa-search form-control-feedback right btn btn-link"
                    style={{
                      height: "100%",
                      margin: "auto",
                      textDecoration: "none",
                    }}
                    aria-hidden="true"
                    onClick={(e) => handleSearch(e)}
                  ></button>
                </div>
              </div>
              <div className="clearfix"></div>
            </div>

            <div className="x_content overflow-auto">
              <TableWrapper
                datas={listsNews}
                tableHead={tableHead}
                tableBody={tableBody}
              />
              <Pagination
                datas={news}
                listsData={newsList}
                search={search}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsIndex;
